<template>
<fragment>
    <header class="gnb" @mouseleave="btnCloseUserPop">
        <div class="header_wrap">
            <div class="left">
                <h1 v-if="['SUPPORT', 'CS', 'VLDPS'].includes(loginSystem)">
                    <!-- Main Button -->
                    <picture>
                        <source srcset="/static/images/logo-mo.png" media="(max-width: 767px)"><!-- mobile -->
                        <source srcset="/static/images/logo.png" media="(max-width: 1023px)"><!-- tablet -->
                        <img src="/static/images/logo.png" alt="Service Knowledge Portal"><!-- pc -->
                    </picture>
                </h1>
                <h1 v-else>
                    <!-- Main Button -->
                    <a href="javascript:" @click="moveMenu()">
                        <picture>
                            <source srcset="/static/images/logo-mo.png" media="(max-width: 767px)"><!-- mobile -->
                            <source srcset="/static/images/logo.png" media="(max-width: 1023px)"><!-- tablet -->
                            <img src="/static/images/logo.png" alt="Service Knowledge Portal"><!-- pc -->
                        </picture>
                    </a>
                </h1>

                <a href="javascript:" class="all" title="all Menu"><span class="sr_only">all Menu</span></a>
                <div class="nav">
                    <!-- dropdown_menu -->
                    <a href="javascript:" class="ico_home" :title="$t('FIELD.GLOBAL.PAGEINFO.HOME')" @click="moveMenu()">
                        <!-- Main Button -->
                        <span class="sr_only">{{ $t('FIELD.GLOBAL.PAGEINFO.HOME') }}</span>
                    </a>
                    <ul class="dropdown scroll">
                        <li v-for="menu in topMenus" :class="menu.pcOnlyYn === 'Y' ? 'pc_only' : 'dir'">
                            <a href="javascript:" :menuId="menu.menuId" @click="clickParent($event)" v-show="mypage(menu.menuId)">{{ menu.menuNm }}</a>
                            <!-- Lv.2 서브메뉴 -->
                            <div class="dropdown_wrap">
                                <dl>
                                    <dt>
                                        {{ menu.menuNm }}
                                    </dt>
                                    <dd v-if="menu.groupMenu">
                                        <ul class="group" v-for="groups in menu.groupMenu">
                                            <li v-if="gMenu.subMenu.length === 0 && gMenu.connUrl !== undefined" v-for="gMenu in groups" :class="{ 'pc_only' : gMenu.pcOnlyYn === 'Y'}">
                                                <a href="javascript:" @click="moveMenu(gMenu)">{{ gMenu.menuNm }}</a>
                                            </li>
                                            <li v-if="gMenu.subMenu.length > 0" v-for="gMenu in groups" class="dir" :class="{ 'pc_only' : gMenu.pcOnlyYn === 'Y'}">
                                                <a href="javascript:" :menuId="gMenu.menuId" @click="clickParent($event)">{{ gMenu.menuNm }}</a>
                                                <ul class="sub_group">
                                                    <li v-if="sub.subMenu.length === 0" v-for="sub in gMenu.subMenu">
                                                        <a href="javascript:" @click="moveMenu(sub)">{{ sub.menuNm }}</a>
                                                    </li>
                                                    <li v-if="sub.subMenu.length > 0" v-for="sub in gMenu.subMenu" class="dir" :class="{ 'pc_only' : sub.pcOnlyYn === 'Y'}">
                                                        <a href="javascript:" :menuId="sub.menuId" @click="clickParent($event)">{{ sub.menuNm }}</a>
                                                        <ul class="sub_group">
                                                            <li v-for="ssub in sub.subMenu">
                                                                <a href="javascript:" @click="moveMenu(ssub)">{{ ssub.menuNm }}</a>
                                                            </li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </dd>
                                </dl>
                            </div>
                        </li>

                        <!-- Support -->
                        <li class="tabmobile_only">
                            <a v-if="loginSystem !== 'SUPPORT'" href="javascript:" class="link_support" :title="$t('TITLE.LEFT.MENU.SUPPORT')" @click="btnSupport">{{ $t('TITLE.LEFT.MENU.SUPPORT') }}<em></em></a>
                            <a v-else href="javascript:" class="link_support" :title="$t('TITLE.LEFT.MENU.KNOWLEDGE')" @click="btnSupport">{{ $t('TITLE.LEFT.MENU.KNOWLEDGE') }}<em></em></a>
                        </li>
                    </ul>

                    <!-- //dropdown_menu -->
                    <a href="javascript:" class="ui_close" @click="uiCloseEvt()"><span class="sr_only">{{ $t('BUTTON.GLOBAL.CLOSE') }}</span></a>
                    <div class="nav_btm">
                        <a href="javascript:" class="ico_lnb_logout" @click="logout"><span class="sr_only">{{ $t('BUTTON.GLOBAL.LOGOUT') }}</span></a>
                        <a href="javascript:" class="ico_lnb_notice" @click="btnNotice">
                            <em v-if="noticeCount > 0" v-show="false">{{noticeCount}}</em>
                            <span class="sr_only" >
                                {{ $t('TITLE.NOTICE.TITLE') }}
                            </span>
                        </a>
                        <!-- <a href="javascript:" class="ico_lnb_favorite"><span class="sr_only">{{ $t('BUTTON.GLOBAL.FAVORITE') }}</span></a> -->
                        <a href="javascript:" class="ico_lnb_setting" @click="btnMySetting"><span class="sr_only">{{ $t('TITLE.MYKNOWLEDGE.USERPREFERENCES') }}</span></a>
                    </div>
                </div>
            </div>

            <div class="function_wrap">
                <ul>
                    <li><a href="javascript:" class="ico_allmenu" @click="btnAllMenu"><span class="sr_only">{{ $t('BUTTON.GLOBAL.ALL.MENU') }}</span></a></li>
                    <li><a href="javascript:" class="ico_search" @click="btnSearch" v-if="'SUPPORT' !== loginSystem"><span class="sr_only">{{ $t('FIELD.GLOBAL.SEARCH') }}</span></a></li>
                    <li><a href="javascript:" class="ico_notice" @click="btnNotice">
                        <em v-if="noticeCount > 0">{{noticeCount}}</em>
                        <span class="sr_only">{{ $t('TITLE.NOTICE.TITLE') }}</span></a></li>
                    <li :class="showUserPop ? 'active' : ''">
                        <a href="javascript:" class="ico_user" @mouseover="btnToggleUserPop">
                            <span class="sr_only">{{ $t('FIELD.GLOBAL.USER') }}</span>
                        </a>
                        <ul class="user_layer">
                            <li class="user_info">[{{ getLoginUser.companyName }}] {{ getLoginUser.loginName }}</li><!-- 200601수정-->
                            <li>
                                <a href="javascript:" @click="btnMySetting"><i class="ico_setting_gnb"></i>{{ $t('TITLE.MYKNOWLEDGE.USERPREFERENCES') }}</a>
                            </li>
                            <li>
                                <a href="javascript:" @click="logout"><i class="ico_logout_gnb"></i>{{ $t('BUTTON.GLOBAL.LOGOUT') }}</a>
                            </li>
                        </ul>
                    </li>
                    <li><span class="confidential">Confidential</span></li>
                </ul>
            </div>
        </div>
    </header>
    <div class="dim"></div>
</fragment>
</template>

<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import _                            from 'lodash';
import $                            from 'jquery';
import axios                        from 'axios';
import qs                           from 'query-string';
import store                        from '@/vuex/store';
import SDLLocale                    from '@/mixin/SDLLocale';
import { SDLUtil, MenuUtil }        from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

import GnbAllMenuPopup              from '~vb/common/GnbAllMenuPopup';
import SearchEntryPopup             from '~vb/intgSearch/SearchEntryPopup';
import NoticeListPopup              from '~va/other/NoticeListPopup';
import NoticeViewPopup              from '~va/other/NoticeViewPopup';
import moment from 'moment';

const updateMenuHistory = menuForm => axios.post(
    `${SDLUtil.API_URL}/basis/common/saveMenuLog.skp`,
    qs.stringify(menuForm),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
);

/**
 * Element.prototype.closest / Element.prototype.matches Polyfill
 * https://developer.mozilla.org/ko/docs/Web/API/Element/closest
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
                                Element.prototype.webkitMatchesSelector;
};

if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
};

export default {
    name: 'SKPGnb',
    mixins: [ SDLLocale ],
    data() {
        return {
            userInfo: null,
            menuList: [],
            allMenuList: [],

            selMenuId: '',
            selMenuList: [],

            showUserPop: false,

            noticeCount: 0,
        }
    },
    computed: {
        ...mapGetters({
            menus: 'getMenus',
            storeParams: 'getParams',
            userCorpCd: 'getCorpCd',
            loginSystem: 'getLoginSystem',
            loginNo: 'getLoginNo',
            loginRhq: 'getLoginRhq',
            deptLevelCd: 'getDeptLevelCd',
        }),
        getLoginUser() {
            return SDLUtil.getLoginedUserInfo();
        },
        topMenus() {
            if(this.menus) {
                let sortedMenus = _.sortBy(this.menus.filter(menu => menu.menuLevel == 1 && menu.subMenu.length > 0), ['sort3']);
                return _.dropRightWhile(sortedMenus, [ 'menuId', 'TOP_1000000003' ]); // My Menu 제거

            } else {
                return [];
            }
        }
    },
    watch: {
        // 메뉴 아이디가 선택되면 이벤트 실행
        selMenuId() {
            this.setBreadcrumbs();
        }
    },
    methods : {
        ...mapActions(['changeSubsidiary', 'setReturnSystem']),
        // 메뉴 반응형 이벤트
        setResponsive(e) {
            if($(window).width() > 1024) { //PC
                /* 서브메뉴 레이어 */
                $('.nav li, .dropdown, .dropdown_wrap').on("mouseover",function(){
                    $(this).children('.dropdown_wrap').css('display', 'block');
                    $(".dim").css('display', 'block');
                    $(':focus').blur();
                });

                $('.nav li, .dropdown, .dropdown_wrap').on("mouseleave",function(){
                    $('.dropdown_wrap').css('display', 'none');
                    $(".dim").css('display', 'none');
                });

            } else if($(window).width() <= 1024) { //Mobile & Tablet
                //Mobile GNB
                $(".all").on("click",function(){
                    var _$height = $(window).height();
                    $('body').addClass("overflow_hidden");
                    $(".nav").addClass("on");
                    $(".nav").height(_$height);
                    $(".dim").css('display', 'block');
                });

                $(".dim").on("click",function(){
                    this.uiCloseEvt();
                });
            }
        },
        getRefineMenu() {
            // vuex 에 메뉴가 있으면 재정의한다.
            if(this.menus) {
                let refineMenus = [];
                const originMenu = this.topMenus;

                // 메뉴 루프 시작
                for(let idx = 0; idx < originMenu.length; idx++) {
                    let refineMenu = originMenu[idx];
                    let subMenu = refineMenu.subMenu;
                    let groupList = [], oldCd = 'NA';

                    // 메뉴 서브가 존재할 시
                    if(subMenu.length > 0) {
                        let group = [];
                        for(let i = 0; i < subMenu.length; i++) {
                            let sortSubMenu = subMenu[i];
                            let menuGrpCd = SDLUtil.nvl(sortSubMenu['menuGroupCd'], 'NA');
                            if(i === 0) {
                                group.push(sortSubMenu);

                            } else {
                                if(oldCd !== menuGrpCd) {
                                    groupList.push(group);
                                    group = [];
                                }

                                group.push(sortSubMenu);
                            }

                            oldCd = menuGrpCd;

                            if(i === (subMenu.length - 1)) {
                                groupList.push(group);
                            }
                        }

                        refineMenu.groupMenu = groupList;
                    }

                    refineMenus.push(refineMenu);
                };

                return refineMenus;

            } else {
                return [];
            }
        },
        // 메뉴 이동 - 메인으로 이동 시 Support 와 일반의 메뉴 이동은 다르게 이동된다.
        moveMenu(menu) {
            if(typeof menu === "undefined") {
                store.commit( 'PARAMS', Object.assign( this.storeParams, { menuId : '', menuGrpCd : '', menuGrpDetailCd : '', creationYn : null } ) );
                if(this.loginSystem == 'SUPPORT' || this.loginSystem == 'CS') {
                    this.$router.push(MenuUtil.getSupportMain());
                } else {
                    this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
                }

            } else {
                this.selMenuId = menu.menuId;
                let connUrl = menu.connUrl.replace('.skp', '');
                this.$log.info('▶ SKPGnb.vue Selected url => ', connUrl);

                store.commit(
                    'PARAMS',
                    Object.assign(
                        this.storeParams,
                        {
                            menuId : menu.menuId,
                            menuPid : menu.menuPid || '',
                            menuGrpCd : menu.menuGroupCd || '',
                            menuGrpDetailCd : menu.menuGroupDetailCd || '',
                            creationYn : menu.creationYn
                        }
                    )
                );

                this.$router.push(connUrl);
            };

            EventBus.$emit('my-menus-reload');

            this.uiCloseEvt();
        },
        clickParent(e) {
            if( e.target.closest('li').classList.contains('active') ) {
                e.target.closest('li').classList.remove('active');

            } else {
                e.target.parentNode.classList.remove('active');
                e.target.closest('li').classList.add('active');
            };
        },
        setBreadcrumbs() {
            if(!SDLUtil.isNull(this.selMenuId)) {
                let scanMenu = MenuUtil.menuScan(this.selMenuId, this.menus), breads = [];
                scanMenu.forEach((menu) => { if(menu.currMenu){ this.boardId = menu.menuNm; breads.push(menu); } });
                for(let i = 0; i < breads[0].depth; i++){
                    let menuPid = breads[i].menuPid;
                    scanMenu.forEach((menu) => { if(menuPid === menu.menuId) breads.push(menu); });
                }

                this.selMenuList = _.sortBy(breads, ['depth']);
                this.updateMenu(this.selMenuId);

            } else {
                this.selMenuList = [];
            }
        },
        // 메뉴 이력 업데이트
        async updateMenu(selMenuId) {
            if(this.selMenuList.length > 0) {
                let menuForm = { menuId : (selMenuId || '') };
                if(!SDLUtil.isNull(menuForm.menuId)) {
                    return await updateMenuHistory(menuForm);
                }
            }
        },
        async btnSupport() {
            // TODO system id 수정 필요
            let reLoginData = { loginSystem : this.loginSystem !== 'SUPPORT' ? 'SUPPORT' : 'WLDPTM' };
            this.setReturnSystem(this.loginSystem);
            if(Number(this.deptLevelCd) === 1) {
                Object.assign(reLoginData, {
                    topRhqCd : this.loginRhq,
                    topSubsidiaryCd : this.userCorpCd,
                });

            } else {
                Object.assign(reLoginData, {
                    topRhqCd : $('#selectRhqCd :selected').val(),
                    topRhqNm : $('#selectRhqCd :selected').html(),
                    topSubsidiaryCd : $('#selectRhqSubCd :selected').val(),
                    topSubsidiaryNm : $('#selectRhqSubCd :selected').html(),
                });
            };

            SDLUtil.showLoadingBar(true);
            const loginResult = await this.changeSubsidiary(reLoginData)
                .catch(err => {
                    SDLUtil.showLoadingBar(false);
                    SDLUtil.errorAlert(err);
                });

            this.afterLoginProcess(loginResult);
        },
        // Support 변경 후 처리
        afterLoginProcess(loginResult) {
            if (loginResult) this.gotoMain();
            EventBus.$emit('router-reload');
            SDLUtil.showLoadingBar(false);
        },
        // 메인 호출 이벤트
        gotoMain() {
            window.scrollTo(0, 0);
            if(this.loginSystem === 'SUPPORT') {
                this.$router.push(MenuUtil.getSupportMain());

            } else {
                this.$router.push('/');
            }
            
        },
        btnAllMenu() {
            SDLUtil.show( GnbAllMenuPopup, { }, { height: 'auto' } );
        },
        // 김남갑 작업 중... 2020.05.11
        btnSearch() {
//            SDLUtil.showLoadingBar(true);
            localStorage.setItem('search.keyword',     '');
            localStorage.setItem('search.screenMode', 'B');
            localStorage.setItem('search.searchKind', 'C');
            SDLUtil.show(
                SearchEntryPopup, {
                    title: 'Model Search',
                    rtnSearchFunc: arg => {
                        const pathUrl = `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/SearchList`;
                        this.$router.push({ path: pathUrl, query: arg });
                    }
                }, // component params
                {
                    height: 'auto',
                }
            );
//            SDLUtil.showLoadingBar(true);
        },
        getNoticeCount(subsidiary) {
            const path = '/basis/admin/other/notice/GetNoticeCount.skp';
            return SDLUtil.getRequest(path);
        },
        getNoticePopups(subsidiary) {
            const path = '/basis/admin/other/notice/popups.skp';
            const params = {
                subsidiaries: this.getCompanyName(),
            };
            return SDLUtil.getRequest(path, params);
        },
        getCompanyName() {
            return JSON.parse(localStorage.getItem('loginUser')).companyName;
        },
        btnNotice() {
            SDLUtil.show(
                NoticeListPopup,
                {
                },
                {
                    height: 'auto',
                    width: '900px',
                }
            );
        },
        btnToggleUserPop() {
            this.showUserPop = !this.showUserPop;
        },
        btnCloseUserPop() {
            this.showUserPop = false;
        },
        btnMySetting() {
            this.$router.push({ name: 'MySetting' });
        },
        uiCloseEvt() {
            // 모바일이 아닐 경우에만 사용
            if(!SDLUtil.isMobile()) {
                $('.dropdown_wrap').css('display', 'none');
                $(".dim").css('display', 'none');
            };
            
            $('body').removeClass("overflow_hidden");
            $(".nav").removeClass("on");
            $(".nav").height('auto');
            $(".dim").css('display', 'none');
        },
        // 로그아웃
        logout() {
            SDLUtil.confirm({
                msg: 'MESSAGE.GLOBAL.LOGOUT',
                okLabel: 'BUTTON.GLOBAL.LOGOUT',
                cancelLabel: 'BUTTON.GLOBAL.CANCEL',
                onOkEvt: () => {
                    this.$router.push({ path: `${SDLUtil.WEB_CONTEXT_PATH}/logout` });
                },
                onCancelEvt: () => { return false; },
            });
        },
        mypage(v) {
            let result = true;
            if(!SDLUtil.isMobile() && 'TOP_1000000003' === v) {
                result = false;
            }
            return result;
        }
    },
    created() {
        window.addEventListener("resize", this.setResponsive);
        EventBus.$on('gnb-menu-event-reload', () => {
            window.addEventListener("resize", this.setResponsive);
            this.$nextTick(() => {
                this.setResponsive();
            });
        });

        this.getNoticeCount()
            .then(data => {
                this.noticeCount = data.count;
            });

        this.getNoticePopups()
            .then(data => {
                this.$log.info('▶ SKPGnb.vue getNoticePopups', data);
                data.result.forEach(item => {
                    if (SDLUtil.isNoticeRead(item.NOTICESEQ.toString())) return;
                    SDLUtil.show(
                        NoticeViewPopup,
                        {
                            seq: item.NOTICESEQ.toString(),
                            mode: 'alert',
                        },
                        {
                            height: 'auto',
                        }
                    );

                })
            });

        this.allMenuList = this.getRefineMenu();
    },
    mounted() {
        // 메뉴 리사이징 이벤트는 DOM 이 생성된 후 실행
        this.$nextTick(() => {
            this.setResponsive();
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setResponsive);
        EventBus.$off('gnb-menu-event-reload');
    },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/SKPGnb.vue